import { useAuth0 } from "@auth0/auth0-react";
import { tryCatchWrapper } from "helpers/common";
import { useEffect } from "react";
import { fetchUsers } from "api/UsersApi";
import { SET_USERS } from "redux/constants/portal";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

export const useUsers = (shouldFetch = true) => {
  const { user } = useAuth0();
  const dispatch = useDispatch();
  const { users } = useSelector((store) => store.portal.users);


  const handleFetchUsers = async () => {
    if (!user) return;

    const usersResponse = await fetchUsers(user.stripeId);

    if (usersResponse && usersResponse.length) {
      const filteredUsers = usersResponse.filter((user) => user.email_address);
      
      dispatch({ type: SET_USERS, payload: filteredUsers });
    }
  };

  useEffect(() => {
    if (!user || users.length || !shouldFetch) return;

    tryCatchWrapper(handleFetchUsers)();
  }, [user, shouldFetch]);

  return {
    users,
    handleFetchUsers
  };
};
